(function() {
  'use strict';
  if (window.__gmAdminBooted) return;
  window.__gmAdminBooted = true;

  var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';
  var RADIO_BUCKET = 'radio-audio';
  var RADIO_COVERS_BUCKET = 'radio-covers';
  var RADIO_MAX_BYTES = 25 * 1024 * 1024;
  var RADIO_COVER_MAX_BYTES = 5 * 1024 * 1024;
  var RADIO_COVER_SOURCE_MAX_BYTES = 20 * 1024 * 1024;
  var RADIO_DEFAULT_EMPTY_ROWS = 3;
  var RADIO_AUDIO_ACCEPT = 'audio/mpeg,audio/wav,audio/x-wav,.mp3,.wav';
  var RADIO_COVER_ACCEPT = 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif';

  function getRadioAudioMeta(file) {
    var name = String(file && file.name || '').toLowerCase();
    var type = String(file && file.type || '').toLowerCase();
    if (
      type === 'audio/wav' ||
      type === 'audio/x-wav' ||
      type === 'audio/wave' ||
      name.endsWith('.wav')
    ) {
      return { ext: 'wav', contentType: 'audio/wav' };
    }
    return { ext: 'mp3', contentType: 'audio/mpeg' };
  }

  function probeAudioDuration(source) {
    return new Promise(function(resolve) {
      if (!source) {
        resolve(null);
        return;
      }
      var audio = new Audio();
      var settled = false;
      function finish(value) {
        if (settled) return;
        settled = true;
        if (typeof source === 'string' && source.indexOf('blob:') === 0) {
          URL.revokeObjectURL(source);
        }
        resolve(value);
      }
      audio.preload = 'metadata';
      audio.addEventListener('loadedmetadata', function() {
        var duration = audio.duration;
        finish(isFinite(duration) && duration > 0 ? Math.round(duration) : null);
      });
      audio.addEventListener('error', function() {
        finish(null);
      });
      window.setTimeout(function() {
        finish(null);
      }, 12000);
      audio.src = source;
    });
  }

  function getAudioDurationSeconds(file, uploadedUrl) {
    if (file) {
      var objectUrl = URL.createObjectURL(file);
      return probeAudioDuration(objectUrl);
    }
    if (uploadedUrl) return probeAudioDuration(uploadedUrl);
    return Promise.resolve(null);
  }

  function isRadioAudioFile(file) {
    if (!file) return false;
    var meta = getRadioAudioMeta(file);
    var type = String(file.type || '').toLowerCase();
    if (!type || type.indexOf('audio/') === 0) return true;
    return meta.ext === 'mp3' || meta.ext === 'wav';
  }

  function isHeicCoverFile(file) {
    var type = String(file && file.type || '').toLowerCase();
    var name = String(file && file.name || '').toLowerCase();
    return (
      type === 'image/heic' ||
      type === 'image/heif' ||
      type === 'image/heic-sequence' ||
      name.endsWith('.heic') ||
      name.endsWith('.heif')
    );
  }

  function isRadioCoverFile(file) {
    if (!file) return false;
    if (isHeicCoverFile(file)) return true;
    var type = String(file.type || '').toLowerCase();
    if (type === 'image/jpeg' || type === 'image/png' || type === 'image/webp') return true;
    var name = String(file.name || '').toLowerCase();
    return /\.(jpe?g|png|webp|heic|heif)$/.test(name);
  }

  function blobToCoverFile(blob, name) {
    return new File([blob], name || 'cover.jpg', { type: blob.type || 'image/jpeg' });
  }

  function loadHeic2Any() {
    if (window.heic2any) return Promise.resolve(window.heic2any);
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      script.onload = function() {
        if (window.heic2any) resolve(window.heic2any);
        else reject(new Error('could not load heic converter'));
      };
      script.onerror = function() {
        reject(new Error('could not load heic converter'));
      };
      document.head.appendChild(script);
    });
  }

  function canvasToJpeg(file, quality) {
    quality = quality || 0.88;
    return new Promise(function(resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function() {
        URL.revokeObjectURL(url);
        var maxDim = 2000;
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        if (!w || !h) {
          reject(new Error('could not read cover photo'));
          return;
        }
        if (w > maxDim || h > maxDim) {
          if (w >= h) {
            h = Math.round(h * maxDim / w);
            w = maxDim;
          } else {
            w = Math.round(w * maxDim / h);
            h = maxDim;
          }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('could not process cover photo'));
          return;
        }
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(function(blob) {
          if (!blob) {
            reject(new Error('could not convert cover photo'));
            return;
          }
          resolve(blobToCoverFile(blob, 'cover.jpg'));
        }, 'image/jpeg', quality);
      };
      img.onerror = function() {
        URL.revokeObjectURL(url);
        reject(new Error('could not read cover photo'));
      };
      img.src = url;
    });
  }

  function convertHeicCover(file) {
    return canvasToJpeg(file).catch(function() {
      return loadHeic2Any().then(function(heic2any) {
        return heic2any({ blob: file, toType: 'image/jpeg', quality: 0.88 });
      }).then(function(result) {
        var blob = Array.isArray(result) ? result[0] : result;
        return blobToCoverFile(blob, 'cover.jpg');
      });
    });
  }

  function prepareRadioCoverFile(file) {
    if (isHeicCoverFile(file)) return convertHeicCover(file);

    var type = String(file.type || '').toLowerCase();
    if (
      (type === 'image/jpeg' || type === 'image/png' || type === 'image/webp') &&
      file.size <= RADIO_COVER_MAX_BYTES
    ) {
      return Promise.resolve(file);
    }

    return canvasToJpeg(file);
  }

  function formatUploadError(errText, bucket) {
    if (!errText) return 'upload failed';
    try {
      var parsed = JSON.parse(errText);
      if (parsed.code === 'NoSuchBucket' || parsed.error === 'Bucket not found') {
        return 'storage bucket "' + bucket + '" is missing — run supabase/radio-storage-setup.sql in the Supabase SQL editor';
      }
      if (parsed.message) return parsed.message;
      if (parsed.error) return parsed.error;
    } catch (e) { /* not json */ }
    return errText;
  }

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDateLabel(value) {
    if (!value) return '';
    var d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return (d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).slice(-2);
  }

  function waitForAuth(maxMs) {
    maxMs = maxMs || 6000;
    return new Promise(function(resolve) {
      if (window.__gmAuth) {
        resolve(window.__gmAuth);
        return;
      }
      var elapsed = 0;
      var timer = window.setInterval(function() {
        elapsed += 100;
        if (window.__gmAuth) {
          window.clearInterval(timer);
          resolve(window.__gmAuth);
          return;
        }
        if (elapsed >= maxMs) {
          window.clearInterval(timer);
          resolve(null);
        }
      }, 100);
    });
  }

  function waitForAuthSettled(maxMs) {
    maxMs = maxMs || 8000;
    return new Promise(function(resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }

      var timer = window.setTimeout(finish, maxMs);
      window.addEventListener('gm-auth-change', function onChange() {
        window.removeEventListener('gm-auth-change', onChange);
        window.clearTimeout(timer);
        finish();
      });

      var auth = window.__gmAuth;
      if (auth && auth.getCurrentUser && auth.getCurrentUser()) {
        window.clearTimeout(timer);
        finish();
      }
    });
  }

  function withTimeout(promise, maxMs, fallback) {
    return new Promise(function(resolve) {
      var settled = false;
      var timer = window.setTimeout(function() {
        if (settled) return;
        settled = true;
        resolve(fallback);
      }, maxMs);
      Promise.resolve(promise).then(function(value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }).catch(function() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(fallback);
      });
    });
  }

  function AdminPage(root) {
    this.root = root;
    this.panel = root.querySelector('[data-gm-admin-panel]');
    this.gate = root.querySelector('[data-admin-gate]');
    this.denied = root.querySelector('[data-admin-denied]');
    this.statusEl = root.querySelector('[data-admin-status]');
    this.activeTab = 'announcements';
    this.busy = false;
    this.bindUi();
  }

  AdminPage.prototype.setStatus = function(text, type) {
    if (!this.statusEl) return;
    this.statusEl.textContent = text || '';
    this.statusEl.classList.toggle('is-error', type === 'error');
    this.statusEl.classList.toggle('is-success', type === 'success');
  };

  AdminPage.prototype.bindUi = function() {
    var self = this;
    this.root.querySelectorAll('[data-admin-tab]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.setActiveTab(btn.getAttribute('data-admin-tab'));
      });
    });

    var announcementForm = this.root.querySelector('[data-admin-announcement-form]');
    if (announcementForm) {
      announcementForm.addEventListener('submit', function(e) {
        e.preventDefault();
        self.submitAnnouncement();
      });
    }

    var radioForm = this.root.querySelector('[data-admin-radio-form]');
    if (radioForm) {
      radioForm.addEventListener('submit', function(e) {
        e.preventDefault();
        self.submitRadioTrack();
      });
    }

    var addRowBtn = this.root.querySelector('[data-admin-radio-add-row]');
    if (addRowBtn) {
      addRowBtn.addEventListener('click', function() {
        self.addRadioRow();
      });
    }

    var saveTableBtn = this.root.querySelector('[data-admin-radio-save]');
    if (saveTableBtn) {
      saveTableBtn.addEventListener('click', function() {
        self.saveRadioTable();
      });
    }

    var discardTableBtn = this.root.querySelector('[data-admin-radio-discard]');
    if (discardTableBtn) {
      discardTableBtn.addEventListener('click', function() {
        self.loadTracks(true);
      });
    }

    var shuffleBtn = this.root.querySelector('[data-admin-radio-shuffle]');
    if (shuffleBtn) {
      shuffleBtn.addEventListener('click', function() {
        self.toggleRadioShuffle();
      });
    }

    var tracksBody = this.root.querySelector('[data-admin-tracks-body]');
    if (tracksBody) {
      tracksBody.addEventListener('input', function(e) {
        var rowEl = e.target.closest('[data-track-row]');
        if (!rowEl) return;
        self.syncRadioRowFromDom(parseInt(rowEl.getAttribute('data-track-row'), 10));
      });
      tracksBody.addEventListener('change', function(e) {
        var input = e.target;
        if (!input || !input.getAttribute('data-field')) return;
        var rowEl = input.closest('[data-track-row]');
        if (!rowEl) return;
        self.handleRadioRowFile(parseInt(rowEl.getAttribute('data-track-row'), 10), input);
      });
      tracksBody.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('[data-remove-row]');
        if (!removeBtn) return;
        var rowEl = removeBtn.closest('[data-track-row]');
        if (!rowEl) return;
        self.removeRadioRow(parseInt(rowEl.getAttribute('data-track-row'), 10));
      });
      tracksBody.addEventListener('paste', function(e) {
        self.handleRadioTablePaste(e);
      });
    }

    this.radioRows = [];
  };

  AdminPage.prototype.setActiveTab = function(tab) {
    if (!tab) return;
    this.activeTab = tab;
    this.root.querySelectorAll('[data-admin-tab]').forEach(function(btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-admin-tab') === tab);
    });
    this.root.querySelectorAll('[data-admin-section]').forEach(function(section) {
      var isActive = section.getAttribute('data-admin-section') === tab;
      section.classList.toggle('is-active', isActive);
      section.hidden = !isActive;
    });
    if (tab === 'announcements') this.loadAnnouncements();
    if (tab === 'radio') {
      this.loadTracks();
      this.loadRadioSettings();
    }
    if (tab === 'chat') this.loadComments();
    if (tab === 'photos') this.loadPhotos();
  };

  AdminPage.prototype.callAdmin = async function(body) {
    var auth = window.__gmAuth;
    if (!auth || typeof auth.getValidAccessToken !== 'function') {
      return { ok: false, error: 'sign in required' };
    }
    var token = await auth.getValidAccessToken();
    if (!token) return { ok: false, error: 'sign in required' };

    var res = await fetch(SUPABASE_URL + '/functions/v1/gm-admin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + token
      },
      body: JSON.stringify(body)
    });

    var data = null;
    try { data = await res.json(); } catch (e) { /* empty */ }
    if (!res.ok || !data) {
      return { ok: false, error: (data && data.error) || ('request failed (' + res.status + ')') };
    }
    return data;
  };

  AdminPage.prototype.showDenied = function() {
    if (this.gate) this.gate.hidden = true;
    if (this.denied) this.denied.hidden = false;
    if (this.panel) this.panel.hidden = true;
  };

  AdminPage.prototype.showPanel = function() {
    if (this.gate) this.gate.hidden = true;
    if (this.denied) this.denied.hidden = true;
    if (this.panel) this.panel.hidden = false;
  };

  AdminPage.prototype.init = async function() {
    if (this._initBusy) return;
    this._initBusy = true;

    if (this.gate) this.gate.hidden = false;
    if (this.denied) this.denied.hidden = true;
    if (this.panel) this.panel.hidden = true;

    try {
      await waitForAuth();
      var auth = window.__gmAuth;
      if (!auth) {
        this.showDenied();
        return;
      }

      await waitForAuthSettled();

      var token = await withTimeout(auth.getValidAccessToken(), 8000, null);
      if (!token) {
        this.showDenied();
        return;
      }

      if (typeof auth.hydrateCurrentProfile === 'function') {
        var user = auth.getCurrentUser && auth.getCurrentUser();
        if (user) {
          await withTimeout(auth.hydrateCurrentProfile(token, user), 8000, null);
        }
      }

      if (!auth.isAdmin || !auth.isAdmin()) {
        this.showDenied();
        return;
      }

      var ping = await withTimeout(this.callAdmin({ mode: 'ping' }), 10000, {
        ok: false,
        error: 'admin service unavailable — redeploy gm-admin edge function'
      });
      if (!ping.ok) {
        this.showDenied();
        this.setStatus(ping.error || 'admin access required', 'error');
        return;
      }

      this.showPanel();
      this.setActiveTab('announcements');
    } catch (e) {
      this.showDenied();
      this.setStatus('could not verify access', 'error');
    } finally {
      this._initBusy = false;
    }
  };

  AdminPage.prototype.loadAnnouncements = async function() {
    var list = this.root.querySelector('[data-admin-announcements-list]');
    if (!list) return;
    list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">loading…</p></li>';
    var result = await this.callAdmin({ mode: 'list_announcements' });
    if (!result.ok) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">' + escHtml(result.error) + '</p></li>';
      return;
    }
    var items = result.announcements || [];
    if (!items.length) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">no announcements yet</p></li>';
      return;
    }
    var self = this;
    list.innerHTML = items.map(function(item) {
      return self.renderAnnouncementItem(item);
    }).join('');
    list.querySelectorAll('[data-delete-announcement]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.deleteAnnouncement(btn.getAttribute('data-delete-announcement'));
      });
    });
  };

  AdminPage.prototype.renderAnnouncementItem = function(item) {
    var deleted = !!item.is_deleted;
    return '<li class="gm-admin-list-item' + (deleted ? ' is-deleted' : '') + '">' +
      '<div class="gm-admin-list-body">' +
        '<p class="gm-admin-list-meta">' + escHtml(formatDateLabel(item.posted_at || item.created_at)) + (deleted ? ' · deleted' : '') + '</p>' +
        '<p class="gm-admin-list-text">' + escHtml(item.body) + '</p>' +
      '</div>' +
      (deleted ? '' : '<button type="button" class="gm-admin-delete-btn" data-delete-announcement="' + escHtml(item.id) + '">delete</button>') +
    '</li>';
  };

  AdminPage.prototype.submitAnnouncement = async function() {
    if (this.busy) return;
    var bodyEl = this.root.querySelector('[data-admin-announcement-body]');
    var text = bodyEl ? bodyEl.value.trim() : '';
    if (!text) return;

    this.busy = true;
    this.setStatus('posting announcement…');
    var result = await this.callAdmin({ mode: 'create_announcement', body: text });
    this.busy = false;

    if (!result.ok) {
      this.setStatus(result.error || 'could not post', 'error');
      return;
    }

    if (bodyEl) bodyEl.value = '';
    this.setStatus('announcement posted', 'success');
    this.loadAnnouncements();
  };

  AdminPage.prototype.deleteAnnouncement = async function(id) {
    if (!id || this.busy) return;
    this.busy = true;
    this.setStatus('deleting announcement…');
    var result = await this.callAdmin({ mode: 'delete_announcement', id: id });
    this.busy = false;
    if (!result.ok) {
      this.setStatus(result.error || 'could not delete', 'error');
      return;
    }
    this.setStatus('announcement deleted', 'success');
    this.loadAnnouncements();
  };

  AdminPage.prototype.uploadRadioFile = async function(file, userId, token) {
    var meta = getRadioAudioMeta(file);
    return this.uploadToStorage(RADIO_BUCKET, file, userId, token, meta.ext, meta.contentType);
  };

  AdminPage.prototype.uploadRadioCover = async function(file, userId, token) {
    var prepared = await prepareRadioCoverFile(file);
    if (prepared.size > RADIO_COVER_MAX_BYTES) {
      throw new Error('cover image must be under 5mb');
    }
    var ext = 'jpg';
    var contentType = 'image/jpeg';
    if (!isHeicCoverFile(file) && prepared.type === 'image/png') {
      ext = 'png';
      contentType = 'image/png';
    } else if (!isHeicCoverFile(file) && prepared.type === 'image/webp') {
      ext = 'webp';
      contentType = 'image/webp';
    }
    return this.uploadToStorage(RADIO_COVERS_BUCKET, prepared, userId, token, ext, contentType);
  };

  AdminPage.prototype.uploadToStorage = async function(bucket, file, userId, token, ext, contentType) {
    var path = userId + '/' + Date.now() + '-' + Math.random().toString(36).slice(2) + '.' + ext;
    var res = await fetch(SUPABASE_URL + '/storage/v1/object/' + bucket + '/' + path, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + token,
        'Content-Type': contentType || file.type || 'application/octet-stream',
        'x-upsert': 'false'
      },
      body: file
    });
    if (!res.ok) {
      var errText = '';
      try { errText = await res.text(); } catch (e) { /* empty */ }
      throw new Error(formatUploadError(errText, bucket));
    }
    return SUPABASE_URL + '/storage/v1/object/public/' + bucket + '/' + path;
  };

  AdminPage.prototype.submitRadioTrack = async function() {
    if (this.busy) return;
    var auth = window.__gmAuth;
    var titleEl = this.root.querySelector('[data-admin-track-title]');
    var artistEl = this.root.querySelector('[data-admin-track-artist]');
    var audioEl = this.root.querySelector('[data-admin-track-audio]');
    var coverEl = this.root.querySelector('[data-admin-track-cover]');
    var orderEl = this.root.querySelector('[data-admin-track-order]');
    var file = audioEl && audioEl.files && audioEl.files[0];
    var coverFile = coverEl && coverEl.files && coverEl.files[0];
    var title = titleEl ? titleEl.value.trim() : '';
    var artist = artistEl ? artistEl.value.trim() : 'going mozart';
    var sortOrder = orderEl ? parseInt(orderEl.value, 10) : 0;

    if (!title || !file) {
      this.setStatus('title and audio file required', 'error');
      return;
    }
    if (file.size > RADIO_MAX_BYTES) {
      this.setStatus('audio file must be under 25mb', 'error');
      return;
    }
    if (!isRadioAudioFile(file)) {
      this.setStatus('audio file must be mp3 or wav', 'error');
      return;
    }
    if (coverFile) {
      if (!isRadioCoverFile(coverFile)) {
        this.setStatus('cover must be jpg, png, webp, or an iphone photo', 'error');
        return;
      }
      if (coverFile.size > RADIO_COVER_SOURCE_MAX_BYTES) {
        this.setStatus('cover photo must be under 20mb', 'error');
        return;
      }
    }

    this.busy = true;
    this.setStatus('uploading track…');

    try {
      var token = await auth.getValidAccessToken();
      if (!token) throw new Error('sign in required');
      var user = auth.getCurrentUser && auth.getCurrentUser();
      if (!user || !user.id) throw new Error('sign in required');
      var audioUrl = await this.uploadRadioFile(file, user.id, token);
      var coverUrl = null;
      if (coverFile) {
        coverUrl = await this.uploadRadioCover(coverFile, user.id, token);
      }
      var durationSeconds = await getAudioDurationSeconds(file, audioUrl);
      var result = await this.callAdmin({
        mode: 'create_radio_track',
        title: title,
        artist: artist,
        audio_url: audioUrl,
        cover_url: coverUrl,
        sort_order: isNaN(sortOrder) ? 0 : sortOrder,
        duration_seconds: durationSeconds
      });
      if (!result.ok) throw new Error(result.error || 'could not save track');

      if (titleEl) titleEl.value = '';
      if (audioEl) audioEl.value = '';
      if (coverEl) coverEl.value = '';
      if (orderEl) orderEl.value = '0';
      this.setStatus('track uploaded', 'success');
      this.loadTracks(true);
    } catch (err) {
      this.setStatus(err.message || 'upload failed', 'error');
    }

    this.busy = false;
  };

  function parsePastedRadioRows(text) {
    var lines = text.split(/\r?\n/).map(function(line) { return line.trim(); }).filter(Boolean);
    return lines.map(function(line, index) {
      var cols = line.indexOf('\t') !== -1 ? line.split('\t') : line.split(',');
      cols = cols.map(function(col) { return col.trim(); });

      var sortOrder = index + 1;
      var title = '';
      var artist = '';

      if (cols.length === 1) {
        title = cols[0];
      } else if (cols.length === 2) {
        if (/^\d+$/.test(cols[0])) {
          sortOrder = parseInt(cols[0], 10) || sortOrder;
          title = cols[1];
        } else {
          title = cols[0];
          artist = cols[1] || artist;
        }
      } else {
        sortOrder = parseInt(cols[0], 10) || sortOrder;
        title = cols[1] || '';
        artist = cols[2] || artist;
      }

      return {
        sort_order: sortOrder,
        title: title,
        artist: artist
      };
    }).filter(function(row) {
      return !!row.title;
    });
  }

  AdminPage.prototype.hasSavedRadioTracks = function() {
    return (this.radioRows || []).some(function(row) { return !!row.id; });
  };

  AdminPage.prototype.isRadioRowEmpty = function(row) {
    if (!row || row.id) return false;
    return !row.title &&
      !row.audio_url &&
      !row.cover_url &&
      !row.pendingAudioFile &&
      !row.pendingCoverFile &&
      (!row.artist);
  };

  AdminPage.prototype.ensureDefaultRadioRows = function() {
    if (!this.radioRows) this.radioRows = [];
    if (this.hasSavedRadioTracks()) return;
    while (this.radioRows.length < RADIO_DEFAULT_EMPTY_ROWS) {
      this.radioRows.push(this.makeRadioRow({ sort_order: this.radioRows.length + 1 }));
    }
  };

  AdminPage.prototype.makeRadioRow = function(item) {
    item = item || {};
    var row = {
      id: item.id || null,
      title: item.title || '',
      artist: item.artist || '',
      sort_order: item.sort_order != null ? item.sort_order : 0,
      audio_url: item.audio_url || '',
      cover_url: item.cover_url || '',
      pendingAudioFile: null,
      pendingCoverFile: null,
      audioLabel: item.audio_url ? 'uploaded' : '',
      coverPreview: ''
    };
    row.original = {
      title: row.title,
      artist: row.artist,
      sort_order: row.sort_order,
      audio_url: row.audio_url,
      cover_url: row.cover_url
    };
    return row;
  };

  AdminPage.prototype.isRadioRowDirty = function(row) {
    if (!row || this.isRadioRowEmpty(row)) return false;
    if (row.pendingAudioFile || row.pendingCoverFile) return true;
    if (!row.id) {
      return !!(row.title || row.audio_url || row.cover_url || row.artist);
    }
    return row.title !== row.original.title ||
      row.artist !== row.original.artist ||
      Number(row.sort_order) !== Number(row.original.sort_order);
  };

  AdminPage.prototype.hasRadioTableChanges = function() {
    var self = this;
    return (this.radioRows || []).some(function(row) {
      return self.isRadioRowDirty(row);
    });
  };

  AdminPage.prototype.updateRadioTableToolbar = function() {
    var hasChanges = this.hasRadioTableChanges();
    var saveBtn = this.root.querySelector('[data-admin-radio-save]');
    var discardBtn = this.root.querySelector('[data-admin-radio-discard]');
    if (saveBtn) saveBtn.hidden = !hasChanges;
    if (discardBtn) discardBtn.hidden = !hasChanges;
  };

  AdminPage.prototype.renderRadioTable = function() {
    var body = this.root.querySelector('[data-admin-tracks-body]');
    var scroll = this.root.querySelector('[data-admin-tracks-scroll]');
    var empty = this.root.querySelector('[data-admin-tracks-empty]');
    if (!body) return;

    this.ensureDefaultRadioRows();
    var rows = this.radioRows || [];

    if (scroll) scroll.hidden = false;
    if (empty) empty.hidden = true;

    var self = this;
    body.innerHTML = rows.map(function(row, index) {
      var dirty = self.isRadioRowDirty(row);
      var coverSrc = row.coverPreview || row.cover_url || '';
      return '<tr class="gm-admin-radio-row' + (dirty ? ' is-dirty' : '') + (!row.id ? ' is-new' : '') + '" data-track-row="' + index + '">' +
        '<td class="gm-admin-radio-cell-order">' +
          '<input type="number" class="gm-admin-table-input gm-admin-table-input-order" data-field="sort_order" value="' + escHtml(row.sort_order) + '" min="0" step="1" />' +
        '</td>' +
        '<td class="gm-admin-radio-cell-cover">' +
          '<div class="gm-admin-table-cover-wrap">' +
            (coverSrc
              ? '<img class="gm-admin-table-cover" src="' + escHtml(coverSrc) + '" alt="" loading="lazy" />'
              : '<span class="gm-admin-table-cover-empty">—</span>') +
            '<label class="gm-admin-table-file-label">' +
              '<input type="file" accept="' + RADIO_COVER_ACCEPT + '" data-field="cover" hidden />' +
              '<span>cover</span>' +
            '</label>' +
          '</div>' +
        '</td>' +
        '<td class="gm-admin-radio-cell-title">' +
          '<input type="text" class="gm-admin-table-input" data-field="title" value="' + escHtml(row.title) + '" placeholder="track title" />' +
        '</td>' +
        '<td class="gm-admin-radio-cell-artist">' +
          '<input type="text" class="gm-admin-table-input" data-field="artist" value="' + escHtml(row.artist) + '" placeholder="artist" />' +
        '</td>' +
        '<td class="gm-admin-radio-cell-audio">' +
          '<div class="gm-admin-table-audio-wrap">' +
            '<span class="gm-admin-table-audio-label">' + escHtml(row.audioLabel || (row.audio_url ? 'uploaded' : 'required')) + '</span>' +
            '<label class="gm-admin-table-file-label">' +
              '<input type="file" accept="' + RADIO_AUDIO_ACCEPT + '" data-field="audio" hidden />' +
              '<span>audio</span>' +
            '</label>' +
          '</div>' +
        '</td>' +
        '<td class="gm-admin-radio-cell-actions">' +
          '<button type="button" class="gm-admin-delete-btn" data-remove-row>remove</button>' +
        '</td>' +
      '</tr>';
    }).join('');

    this.updateRadioTableToolbar();
  };

  AdminPage.prototype.syncRadioRowFromDom = function(index) {
    var row = this.radioRows[index];
    var rowEl = this.root.querySelector('[data-track-row="' + index + '"]');
    if (!row || !rowEl) return;

    var orderEl = rowEl.querySelector('[data-field="sort_order"]');
    var titleEl = rowEl.querySelector('[data-field="title"]');
    var artistEl = rowEl.querySelector('[data-field="artist"]');
    if (orderEl) row.sort_order = parseInt(orderEl.value, 10) || 0;
    if (titleEl) row.title = titleEl.value.trim();
    if (artistEl) row.artist = artistEl.value.trim();

    rowEl.classList.toggle('is-dirty', this.isRadioRowDirty(row));
    this.updateRadioTableToolbar();
  };

  AdminPage.prototype.handleRadioRowFile = function(index, input) {
    var row = this.radioRows[index];
    if (!row || !input || !input.files || !input.files[0]) return;
    var file = input.files[0];
    var field = input.getAttribute('data-field');

    if (field === 'audio') {
      if (file.size > RADIO_MAX_BYTES) {
        this.setStatus('audio file must be under 25mb', 'error');
        input.value = '';
        return;
      }
      if (!isRadioAudioFile(file)) {
        this.setStatus('audio file must be mp3 or wav', 'error');
        input.value = '';
        return;
      }
      row.pendingAudioFile = file;
      row.audioLabel = file.name;
    }

    if (field === 'cover') {
      if (!isRadioCoverFile(file)) {
        this.setStatus('cover must be jpg, png, webp, or an iphone photo', 'error');
        input.value = '';
        return;
      }
      if (file.size > RADIO_COVER_SOURCE_MAX_BYTES) {
        this.setStatus('cover photo must be under 20mb', 'error');
        input.value = '';
        return;
      }
      var self = this;
      this.setStatus('processing cover…');
      prepareRadioCoverFile(file).then(function(prepared) {
        if (prepared.size > RADIO_COVER_MAX_BYTES) {
          self.setStatus('cover image must be under 5mb — try a smaller photo', 'error');
          input.value = '';
          return;
        }
        row.pendingCoverFile = prepared;
        if (row.coverPreview) URL.revokeObjectURL(row.coverPreview);
        row.coverPreview = URL.createObjectURL(prepared);
        self.renderRadioTable();
        self.setStatus('');
      }).catch(function(err) {
        self.setStatus(err.message || 'could not process cover photo', 'error');
        input.value = '';
      });
      return;
    }

    this.renderRadioTable();
    this.setStatus('');
  };

  AdminPage.prototype.addRadioRow = function() {
    if (!this.radioRows) this.radioRows = [];
    var nextOrder = 0;
    this.radioRows.forEach(function(row) {
      nextOrder = Math.max(nextOrder, Number(row.sort_order) || 0);
    });
    this.radioRows.push(this.makeRadioRow({ sort_order: nextOrder + 1 }));
    this.renderRadioTable();
    this.updateRadioTableToolbar();
  };

  AdminPage.prototype.removeRadioRow = async function(index) {
    var row = this.radioRows[index];
    if (!row) return;

    if (!row.id) {
      if (row.coverPreview) URL.revokeObjectURL(row.coverPreview);
      this.radioRows.splice(index, 1);
      this.ensureDefaultRadioRows();
      this.renderRadioTable();
      return;
    }

    if (this.busy) return;
    this.busy = true;
    this.setStatus('removing track…');
    var result = await this.callAdmin({ mode: 'delete_radio_track', id: row.id });
    this.busy = false;
    if (!result.ok) {
      this.setStatus(result.error || 'could not remove', 'error');
      return;
    }
    this.setStatus('track removed', 'success');
    this.loadTracks(true);
  };

  AdminPage.prototype.handleRadioTablePaste = function(e) {
    var text = e.clipboardData && e.clipboardData.getData('text/plain');
    if (!text || !text.trim()) return;
    if (text.indexOf('\t') === -1 && text.indexOf('\n') === -1 && text.indexOf(',') === -1) return;

    var parsed = parsePastedRadioRows(text);
    if (!parsed.length) return;

    e.preventDefault();

    var startIndex = 0;
    var target = e.target;
    if (target && target.closest && target.closest('[data-track-row]')) {
      startIndex = parseInt(target.closest('[data-track-row]').getAttribute('data-track-row'), 10) || 0;
    }

    var needed = startIndex + parsed.length;
    while (this.radioRows.length < needed) {
      this.radioRows.push(this.makeRadioRow({ sort_order: this.radioRows.length + 1 }));
    }

    for (var i = 0; i < parsed.length; i++) {
      var row = this.radioRows[startIndex + i];
      if (!row) {
        row = this.makeRadioRow({ sort_order: parsed[i].sort_order });
        this.radioRows.push(row);
      }
      if (row.id) continue;
      row.sort_order = parsed[i].sort_order;
      row.title = parsed[i].title;
      row.artist = parsed[i].artist || '';
    }

    this.renderRadioTable();
    this.setStatus('pasted ' + parsed.length + ' row' + (parsed.length === 1 ? '' : 's'), 'success');
  };

  AdminPage.prototype.saveRadioTable = async function() {
    if (this.busy) return;
    var auth = window.__gmAuth;
    var dirtyRows = [];
    var self = this;
    (this.radioRows || []).forEach(function(row, index) {
      if (self.isRadioRowDirty(row)) dirtyRows.push({ row: row, index: index });
    });

    if (!dirtyRows.length) {
      this.setStatus('no changes to save');
      return;
    }

    for (var i = 0; i < dirtyRows.length; i++) {
      var entry = dirtyRows[i];
      if (!entry.row.title) continue;
      if (!entry.row.id && !entry.row.pendingAudioFile && !entry.row.audio_url) {
        this.setStatus('new rows with titles need an audio file before saving', 'error');
        return;
      }
    }

    dirtyRows = dirtyRows.filter(function(entry) {
      return entry.row.title;
    });

    if (!dirtyRows.length) {
      this.setStatus('add titles before saving');
      return;
    }

    this.busy = true;
    this.setStatus('saving queue…');

    try {
      var token = await auth.getValidAccessToken();
      if (!token) throw new Error('sign in required');
      var user = auth.getCurrentUser && auth.getCurrentUser();
      if (!user || !user.id) throw new Error('sign in required');

      for (var j = 0; j < dirtyRows.length; j++) {
        var item = dirtyRows[j].row;
        var audioUrl = item.audio_url;
        var coverUrl = item.cover_url || null;

        if (item.pendingAudioFile) {
          audioUrl = await this.uploadRadioFile(item.pendingAudioFile, user.id, token);
        }
        if (item.pendingCoverFile) {
          coverUrl = await this.uploadRadioCover(item.pendingCoverFile, user.id, token);
        }

        if (!item.id) {
          var durationSeconds = null;
          if (item.pendingAudioFile) {
            durationSeconds = await getAudioDurationSeconds(item.pendingAudioFile, audioUrl);
          }
          var created = await this.callAdmin({
            mode: 'create_radio_track',
            title: item.title,
            artist: item.artist,
            audio_url: audioUrl,
            cover_url: coverUrl,
            sort_order: item.sort_order,
            duration_seconds: durationSeconds
          });
          if (!created.ok) throw new Error(created.error || 'could not create track');
        } else {
          var payload = {
            mode: 'update_radio_track',
            id: item.id,
            title: item.title,
            artist: item.artist,
            sort_order: item.sort_order
          };
          if (item.pendingAudioFile) payload.audio_url = audioUrl;
          if (item.pendingCoverFile) payload.cover_url = coverUrl;
          if (item.pendingAudioFile) {
            payload.duration_seconds = await getAudioDurationSeconds(item.pendingAudioFile, audioUrl);
          }
          var updated = await this.callAdmin(payload);
          if (!updated.ok) throw new Error(updated.error || 'could not update track');
        }
      }

      this.setStatus('queue saved', 'success');
      this.loadTracks(true);
    } catch (err) {
      this.setStatus(err.message || 'save failed', 'error');
    }

    this.busy = false;
  };

  AdminPage.prototype.setShuffleUi = function(enabled) {
    var btn = this.root.querySelector('[data-admin-radio-shuffle]');
    if (!btn) return;
    btn.classList.toggle('is-active', !!enabled);
    btn.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    btn.textContent = enabled ? 'Shuffle On' : 'Shuffle Off';
  };

  AdminPage.prototype.loadRadioSettings = async function() {
    var result = await this.callAdmin({ mode: 'get_radio_settings' });
    if (result.ok) this.setShuffleUi(!!result.shuffle_enabled);
  };

  AdminPage.prototype.toggleRadioShuffle = async function() {
    if (this.busy) return;
    var btn = this.root.querySelector('[data-admin-radio-shuffle]');
    var nextEnabled = !(btn && btn.classList.contains('is-active'));

    this.busy = true;
    this.setStatus(nextEnabled ? 'turning shuffle on…' : 'turning shuffle off…');

    var result = await this.callAdmin({
      mode: 'set_radio_shuffle',
      shuffle_enabled: nextEnabled
    });

    this.busy = false;
    if (!result.ok) {
      this.setStatus(result.error || 'could not update shuffle', 'error');
      return;
    }

    this.setShuffleUi(!!result.shuffle_enabled);
    this.setStatus(result.shuffle_enabled ? 'shuffle on — songs play in random order' : 'shuffle off — songs play in queue order', 'success');
  };

  AdminPage.prototype.loadTracks = async function(force) {
    var body = this.root.querySelector('[data-admin-tracks-body]');
    var empty = this.root.querySelector('[data-admin-tracks-empty]');
    if (!body) return;

    if (!force && this.hasRadioTableChanges()) return;

    if (empty) {
      empty.hidden = false;
      empty.textContent = 'loading queue…';
    }
    body.innerHTML = '';
    var scroll = this.root.querySelector('[data-admin-tracks-scroll]');
    if (scroll) scroll.hidden = true;

    var result = await this.callAdmin({ mode: 'list_radio_tracks' });
    if (!result.ok) {
      if (empty) empty.textContent = result.error || 'could not load queue';
      return;
    }

    var items = (result.tracks || []).filter(function(t) { return t.is_active !== false; });
    this.radioRows = items.map(function(item) {
      return this.makeRadioRow(item);
    }, this);
    if (!this.radioRows.length) {
      for (var i = 0; i < RADIO_DEFAULT_EMPTY_ROWS; i++) {
        this.radioRows.push(this.makeRadioRow({ sort_order: i + 1 }));
      }
    }
    this.renderRadioTable();
  };

  AdminPage.prototype.loadComments = async function() {
    var list = this.root.querySelector('[data-admin-comments-list]');
    if (!list) return;
    list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">loading…</p></li>';
    var result = await this.callAdmin({ mode: 'list_comments', limit: 50 });
    if (!result.ok) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">' + escHtml(result.error) + '</p></li>';
      return;
    }
    var items = result.comments || [];
    if (!items.length) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">no messages</p></li>';
      return;
    }
    var self = this;
    list.innerHTML = items.map(function(item) {
      var username = item.profiles && item.profiles.username ? item.profiles.username : 'user';
      var preview = item.body || (item.media_url ? ('[' + (item.media_type || 'media') + ']') : '');
      var deleted = !!item.is_deleted;
      return '<li class="gm-admin-list-item' + (deleted ? ' is-deleted' : '') + '">' +
        '<div class="gm-admin-list-body">' +
          '<p class="gm-admin-list-meta">@' + escHtml(username) + ' · ' + escHtml(formatDateLabel(item.created_at)) + (deleted ? ' · deleted' : '') + '</p>' +
          '<p class="gm-admin-list-text">' + escHtml(preview) + '</p>' +
        '</div>' +
        (deleted ? '' : '<button type="button" class="gm-admin-delete-btn" data-delete-comment="' + escHtml(item.id) + '">delete</button>') +
      '</li>';
    }).join('');
    list.querySelectorAll('[data-delete-comment]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.deleteComment(btn.getAttribute('data-delete-comment'));
      });
    });
  };

  AdminPage.prototype.deleteComment = async function(id) {
    if (!id || this.busy) return;
    this.busy = true;
    this.setStatus('deleting message…');
    var result = await this.callAdmin({ mode: 'delete_comment', id: id });
    this.busy = false;
    if (!result.ok) {
      this.setStatus(result.error || 'could not delete', 'error');
      return;
    }
    this.setStatus('message deleted', 'success');
    this.loadComments();
  };

  AdminPage.prototype.loadPhotos = async function() {
    var list = this.root.querySelector('[data-admin-photos-list]');
    if (!list) return;
    list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">loading…</p></li>';
    var result = await this.callAdmin({ mode: 'list_photos', limit: 50 });
    if (!result.ok) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">' + escHtml(result.error) + '</p></li>';
      return;
    }
    var items = result.photos || [];
    if (!items.length) {
      list.innerHTML = '<li class="gm-admin-list-item"><p class="gm-admin-list-text">no photos</p></li>';
      return;
    }
    var self = this;
    list.innerHTML = items.map(function(item) {
      var username = item.profiles && item.profiles.username ? item.profiles.username : 'user';
      var deleted = !!item.is_deleted;
      return '<li class="gm-admin-list-item' + (deleted ? ' is-deleted' : '') + '">' +
        (item.image_url ? '<img class="gm-admin-list-thumb" src="' + escHtml(item.image_url) + '" alt="" loading="lazy" />' : '') +
        '<div class="gm-admin-list-body">' +
          '<p class="gm-admin-list-meta">@' + escHtml(username) + ' · ' + escHtml(formatDateLabel(item.created_at)) + (deleted ? ' · deleted' : '') + '</p>' +
        '</div>' +
        (deleted ? '' : '<button type="button" class="gm-admin-delete-btn" data-delete-photo="' + escHtml(item.id) + '">delete</button>') +
      '</li>';
    }).join('');
    list.querySelectorAll('[data-delete-photo]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.deletePhoto(btn.getAttribute('data-delete-photo'));
      });
    });
  };

  AdminPage.prototype.deletePhoto = async function(id) {
    if (!id || this.busy) return;
    this.busy = true;
    this.setStatus('deleting photo…');
    var result = await this.callAdmin({ mode: 'delete_photo', id: id });
    this.busy = false;
    if (!result.ok) {
      this.setStatus(result.error || 'could not delete', 'error');
      return;
    }
    this.setStatus('photo deleted', 'success');
    this.loadPhotos();
  };

  function initAdminPage() {
    var root = document.querySelector('[data-gm-admin-page]');
    if (!root || root.__gmAdminReady) return;
    root.__gmAdminReady = true;
    var page = new AdminPage(root);
    page.init();
    window.addEventListener('gm-auth-change', function() {
      if (page.panel && !page.panel.hidden) return;
      page.init();
    });
  }

  document.addEventListener('DOMContentLoaded', initAdminPage);
})();
